import type { ReactNode } from "react";

export const emptyStateActionClass = "inline-flex h-9 items-center justify-center rounded-md border border-slate-200 bg-white px-3 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50";

export default function EmptyState({ title, children, actions, alert = false }: {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
  alert?: boolean;
}) {
  return (
    <div role={alert ? "alert" : "status"} className="mx-auto max-w-xl py-4 text-center text-sm">
    <p className="font-semibold text-slate-900">{title}</p>
    <div className="mt-2 leading-relaxed text-slate-600">{children}</div>
    {actions && <div className="mt-4 flex flex-wrap justify-center gap-2">{actions}</div>}
    </div>
  );
}
